<div class="popup-content">
  <div class="image-notice">
    <img src="../../../../assets/images/icons/upload.svg" alt="" />
  </div>
  <div class="d-flex mb-3 mt-3">
        <a href="assets/documents/File update NAV.xlsx" target="blank">Tải File Template</a>
    </div>
  <div class="d-flex flex-row m-t-15 m-b-15">
    <button class="btn-chooseFile" (click)="uploadFile()">Chọn file</button>
    <input type="text" value="" placeholder="Tên file" [(ngModel)]="fileName" />
    <input
      id="fileInput"
      #fileInput
      style="display: none"
      name="file"
      type="file"
      (change)="selectFile($event)"
    />
  </div>
  <div class="d-flex" *ngIf="list.length">
    <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
        <thead>
          <tr>
            <th>Sản phẩm</th>
            <th>NAV trước</th>
            <th>NAV cập nhật</th>
            <th>Thay đổi</th>
            <th>Ngày</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of list;">
            <td [style.color]="item.isHighligt ? 'red' : 'black'">{{item.code}}</td>
            <td [style.color]="item.isHighligt ? 'red' : 'black'">{{item.currentNav | number}}</td>
            <td [style.color]="item.isHighligt ? 'red' : 'black'">{{item.nav | number}}</td>
            <td [style.color]="item.isHighligt ? 'red' : 'black'">{{item.percentChange | number}}%</td>
            <td [style.color]="item.isHighligt ? 'red' : 'black'">{{item.date}}</td>
          </tr>
        </tbody>
      </nz-table>
  </div>

  <div class="modal-footer">
    <button class="ant-btn ng-star-inserted ant-btn-primary" (click)="save()">
      Gửi yêu cầu
    </button>
  </div>
</div>
